<template>
  <v-dialog v-model="infoDialog">
    <template v-slot:activator="{ on: dialogOn, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: slotOn }">
          <v-avatar v-on="{ ...dialogOn, ...slotOn }" v-bind="attrs" slot="activator">
            <v-icon>mdi-bullhorn</v-icon>
          </v-avatar>
        </template>
        <span>{{ $t('noticeOfRecommendedMaintenanceMachines') }}</span>
      </v-tooltip>
    </template>

    <!-- メンテナンス通知 -->
    <v-card v-if="items.length > 0">
      <v-data-table
        dense
        :headers="headers"
        :items="items"
        hide-default-footer
        item-key="id"
        :items-per-page="-1"
        class="v-data-table-outlined"
      >
        <template v-slot:[`item.noticeOfRecommendedMaintenanceMachines`]="{ item }">
          <span v-html="item.noticeOfRecommendedMaintenanceMachines"></span>
        </template>
        <template v-slot:[`item.notDisplayedFor30Days`]="{ item }">
          <v-checkbox v-model="item.notDisplayedFor30Days" dense hide-details></v-checkbox>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveMaintenanceNotifications" dark small depressed
          ><v-icon>mdi-checkbox-marked-circle-outline</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
    <!-- レコードが1件もない場合 -->
    <v-card v-else>
      <v-card-title>{{ $t('noMachinesRecommendedForImmediateInspectionAndMaintenance') }}</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog" dark small depressed><v-icon>mdi-close</v-icon></v-btn>
      </v-card-actions></v-card
    >
  </v-dialog>
</template>

<script>
  export default {
    name: 'MaintenanceNotifications',
    props: {
      userId: null,
    },
    data: () => ({
      items: [],
      infoDialog: false,
    }),
    computed: {
      headers() {
        return [
          {
            text: this.$t('noticeOfRecommendedMaintenanceMachines'),
            align: 'start',
            value: 'noticeOfRecommendedMaintenanceMachines',
            sortable: false,
          },
          { text: this.$t('notDisplayedFor30Days'), align: 'start', value: 'notDisplayedFor30Days', sortable: false },
        ];
      },
    },
    watch: {
      '$i18n.locale'() {
        this.setData();
      },
    },
    async created() {
      await this.getMaintenanceNotifications();
    },
    methods: {
      async getMaintenanceNotifications() {
        // メンテナンス通知を取得
        const res = await this.azureRequest('/api/getMaintenanceNotifications', 'GET', {
          userId: this.userId,
        });
        if (res) {
          this.items = res;
          this.setData();
        }
      },
      async saveMaintenanceNotifications() {
        const disabledDate = this.$dayjs.jst().format('YYYY-MM-DD HH:mm:ss');

        // 30日間表示しないにチェックを付けたアイテムにdisabledDateを更新する
        for (const item of this.items.filter((item) => item.notDisplayedFor30Days)) {
          const body = {
            id: item.id,
            userId: item.userId,
            equipmentNo: item.equipmentNo,
            customerManagementNo: item.customerManagementNo,
            status: item.status,
            disabledDate: disabledDate,
            elapsedDays: item.elapsedDays,
            fkadotm: item.fkadotm,
          };
          await this.azureRequest('/api/putMaintenanceNotification', 'PUT', body);
        }

        // 30日間表示しないにチェックを付けたアイテムを非表示に
        this.items = this.items.filter((item) => !item.notDisplayedFor30Days);

        // 需要家画面の場合、リロード
        if (this.$route.name === 'HomeConsumer') {
          this.$emit('reloadRouterView');
        }

        this.infoDialog = false;
      },
      setData() {
        for (const item of this.items) {
          let message = item.equipmentNo;
          if (item.customerManagementNo) {
            message += `(${item.customerManagementNo})`;
          }
          message += ': ';
          let tmp, color;
          switch (item.status) {
            case 'notice':
              color = 'green';
              tmp = this.$t('servicingTimeIsApproaching');
              break;
            case 'warning':
              color = '#FFA500';
              tmp = this.$t('earlyServicingIsRequired');
              break;
            case 'danger':
              color = '#FF0000';
              tmp = this.$t('immediateServicingIsRequired');
              break;
          }
          message += `<span style="color: ${color};">${tmp}</span>`;
          item.noticeOfRecommendedMaintenanceMachines = message;
          item.notDisplayedFor30Days = false;
        }
      },
      closeDialog() {
        this.infoDialog = false;
      },
    },
  };
</script>
